"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateComparisonCache = exports.formatComparisonResults = void 0;
const common_1 = require("@finley-technologies/common");
const comparisonCache = {};
const formatComparisonResults = () => {
    const formattedResults = [];
    let matches = 0;
    let errors = 0;
    // Formula comparisons
    Object.entries(comparisonCache).forEach(([formula, results]) => {
        if (results.error || results.mismatch) {
            errors += 1;
            formattedResults.push(`[FormulaEngine TEST] ERROR | Match: ${results.match} | Mismatch: ${results.mismatch} | Error: ${results.error} | Formula: ${formula}`);
        }
        else {
            matches += 1;
        }
    });
    if (errors || matches) {
        // dont spam output of every process.
        formattedResults.push(`[FormulaEngine TEST] Full matches: ${matches}`);
    }
    return formattedResults;
};
exports.formatComparisonResults = formatComparisonResults;
const updateComparisonCache = ({ formula, result, }) => {
    try {
        // Retrieve cached comparison results for formula
        const comparisonResult = comparisonCache[formula] ?? {
            match: 0,
            mismatch: 0,
            error: 0,
        };
        // Set comparison cache if not already available
        comparisonCache[formula] = comparisonResult;
        switch (result) {
            case 'match':
                comparisonResult.match += 1;
                break;
            case 'mismatch':
                comparisonResult.mismatch += 1;
                break;
            case 'error':
                comparisonResult.error += 1;
                break;
            default:
                (0, common_1.finleyAssertUnreachable)(result);
        }
    }
    catch {
        // no-op
    }
};
exports.updateComparisonCache = updateComparisonCache;
if (process) {
    process.on('exit', () => {
        const formattedResults = (0, exports.formatComparisonResults)();
        if (formattedResults.length) {
            // eslint-disable-next-line no-console
            (0, common_1.debugLog)('Formula engine comparison results', {
                formattedResults,
            });
        }
    });
}
//# sourceMappingURL=comparison.js.map